import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "bg-gray-100 rounded-md flex py-2 px-4"
};
const _hoisted_2 = {
  class: "flex-auto text-left"
};
const _hoisted_3 = {
  class: "flex-auto text-center"
};
const _hoisted_4 = {
  class: "flex-auto text-right"
};
import { onMounted, ref } from 'vue';
import { useInvoiceEditorStore } from '@/modules/billing/invoice/services/useInvoiceEditorStore.js';
import { useInvoiceState } from '@/modules/billing/review/editDraft/useInvoiceState';
import { useSnackbarHandler } from '@/composables/useSnackbarHandler';
export default {
  __name: 'InvoiceUserInfo',
  setup(__props) {
    const accounts = ref({
      primary: [],
      originating: [],
      reviewer: []
    });
    const invoiceEditorStore = useInvoiceEditorStore();
    const invoiceState = useInvoiceState();
    const {
      id
    } = invoiceState;
    const {
      handleError
    } = useSnackbarHandler();
    onMounted(async () => {
      try {
        const response = await invoiceEditorStore.getInvoiceAccounts({
          id
        });
        accounts.value = response.data;
      } catch (error) {
        handleError(error);
      }
    });
    const formattedNames = users => {
      return users.map(user => user.initials || user.name).join(', ');
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_cache[0] || (_cache[0] = _createElementVNode("b", null, "Responsible", -1)), _cache[1] || (_cache[1] = _createElementVNode("br", null, null, -1)), _createElementVNode("span", null, _toDisplayString(formattedNames(accounts.value.primary)), 1)]), _createElementVNode("div", _hoisted_3, [_cache[2] || (_cache[2] = _createElementVNode("b", null, "Originator", -1)), _cache[3] || (_cache[3] = _createElementVNode("br", null, null, -1)), _createElementVNode("span", null, _toDisplayString(formattedNames(accounts.value.originating)), 1)]), _createElementVNode("div", _hoisted_4, [_cache[4] || (_cache[4] = _createElementVNode("b", null, "Reviewer", -1)), _cache[5] || (_cache[5] = _createElementVNode("br", null, null, -1)), _createElementVNode("span", null, _toDisplayString(formattedNames(accounts.value.reviewer)), 1)])]);
    };
  }
};